var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErrorInApp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#afb4c8;}.cls-2{fill:#e1e4ed;}.cls-3{fill:#ade1fa;}.cls-4{fill:#cdd2e1;}.cls-5{fill:#8ed8f8;}.cls-6{fill:#d4effc;}.cls-7{fill:#99a1b1;}.cls-8{fill:#f26973;}.cls-9{fill:#e65263;}.cls-10{fill:#393045;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "02-error") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_02-error",
    "data-name": "02-error"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "41 47 43 55 21 55 23 47 41 47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M46,55a2.006,2.006,0,0,1,2,2,2.015,2.015,0,0,1-2,2H18a2.006,2.006,0,0,1-2-2,2.015,2.015,0,0,1,2-2H46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M63,41v2a4,4,0,0,1-4,4H5a4,4,0,0,1-4-4V41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M63,9V41H1V9A4,4,0,0,1,5,5H59A4,4,0,0,1,63,9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M7,43V41H1v2a4,4,0,0,0,4,4h6A4,4,0,0,1,7,43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M11,5H5A4,4,0,0,0,1,9V41H7V9A4,4,0,0,1,11,5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M57,43V41h6v2a4,4,0,0,1-4,4H53A4,4,0,0,0,57,43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M53,5h6a4,4,0,0,1,4,4V41H57V9A4,4,0,0,0,53,5Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "41 47 23 47 22 51 42 51 41 47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M18,59H46a2.015,2.015,0,0,0,2-2H16A2.006,2.006,0,0,0,18,59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M32,9A14,14,0,1,1,18,23,14,14,0,0,1,32,9Zm1,16,1-12H30l1,12Zm1,5a2,2,0,1,0-2,2A2.006,2.006,0,0,0,34,30Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M32,9a13.994,13.994,0,0,0-12.428,7.572,13.96,13.96,0,0,1,10.649-.921L30,13h4l-.357,4.28a13.965,13.965,0,0,1,4.785,18.148A13.994,13.994,0,0,0,32,9Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "34 13 33 25 31 25 30 13 34 13"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 32,
    cy: 30,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M59,4H5A5.006,5.006,0,0,0,0,9V43a5.006,5.006,0,0,0,5,5H21.719l-1.5,6H18a3.015,3.015,0,0,0-3,3,3,3,0,0,0,3,3H46a3.015,3.015,0,0,0,3-3,3,3,0,0,0-3-3H43.781l-1.5-6H59a5.006,5.006,0,0,0,5-5V9A5.006,5.006,0,0,0,59,4ZM5,6H59a3,3,0,0,1,3,3V40H2V9A3,3,0,0,1,5,6ZM47,57a.974.974,0,0,1-.306.712A.957.957,0,0,1,46,58H18a1,1,0,0,1-1-1,.974.974,0,0,1,.306-.712A.957.957,0,0,1,18,56H46A1,1,0,0,1,47,57ZM22.281,54l1.5-6H40.219l1.5,6ZM59,46H5a3,3,0,0,1-3-3V42H62v1A3,3,0,0,1,59,46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M32,38A15,15,0,1,0,17,23,15.017,15.017,0,0,0,32,38Zm0-28A13,13,0,1,1,19,23,13.015,13.015,0,0,1,32,10Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M32,33a3,3,0,1,0-3-3A3,3,0,0,0,32,33Zm0-4a1,1,0,1,1-1,1A1,1,0,0,1,32,29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M31,26h2a1,1,0,0,0,1-.917l1-12A1,1,0,0,0,34,12H30a1,1,0,0,0-1,1.083l1,12A1,1,0,0,0,31,26Zm1.913-12L32.08,24h-.16l-.833-10Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorInApp);
export default __webpack_public_path__ + "static/media/errorInApp.74cf091cab1153b088630f81edc5302a.svg";
export { ForwardRef as ReactComponent };